import { lazy } from 'react';

export const AppraiserOrderAsync = lazy(() => import('./AppraiserOrder'));
